export * from './status-movimentacao-cadastral-manual.pipe';
